import { motion } from 'framer-motion'
import { Typography } from '@mui/material';

export default function Name() {

    const delay = (i) => { return 1 + i * 0.3; }

    return (
        <motion.div style={{
            display: 'flex',
        }}>
            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(0), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">K</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(0.2), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">o</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(0.4), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">r</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(0.6), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">d</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(0.8), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">.</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(1), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">M</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(1.2), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">A</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(1.4), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">u</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(1.6), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">r</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(1.8), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">e</Typography>

            <Typography
                component={motion.h2}
                sx={{ fontSize: { xs: "2.75rem", sm: "3.75rem" } }}
                transition={{ type: 'spring', bounce: 0.5, delay: delay(2), ease: 'easeIn', duration: 0.5 }}
                initial={{ y: -125, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                variant="h2"
                color="primary">r</Typography>
        </motion.div>
    )
}